import { environment } from 'environments/environment';
import { OptionsInput } from 'fullcalendar/src/types/input-types';

const generateBaseUrl = function(baseUrl) {
  return baseUrl.replace('{hostname}', document.location.hostname);
}

export const Config = {
	language: 'it',
	baseURL: generateBaseUrl(environment.baseURL),
	webSocketURI: generateBaseUrl(environment.webSocketURI),
	defaultCalendarOptions: <OptionsInput>{
		aspectRatio: 16 / 9,
		locale: 'it',
		header: {
			left: 'prev,next,today, SalaAttesa',
			center: 'title',
			right: 'listWeek,agendaDay,agendaWeek,month'
		},
		height: () => $(window).height() - 130,
		firstDay: 1,
		fixedWeekCount: false,
		eventLimit: true,
		editable: true,
		navLinks: true, // can click day/week names to navigate views
		selectHelper: true,
		nowIndicator: true
	},
	defaultQtip2Options: <QTip2.QTipOptions>{
		style: {
			classes: 'qtip-bootstrap'
		},
		position: {
			my: 'top center',
			at: 'bottom center'
		},
		hide: {
			fixed: true
		}
	},
	doubleClickTime: 250,
	searchDebounceTime: 250,
	codiceFiscaleDebounceTime: 250,
	contatti: {
		pageSize: 6
	},
	pazienti: {
		refreshInterval: 30 * 60 * 1000 // ms
	},
	fuse: {
		shouldSort: true,
		threshold: 0.6,
		location: 0,
		distance: 100,
		maxPatternLength: 32
	},
	copyrightBaseYear: 2018
};



// WEBPACK FOOTER //
// ./src/app/config.const.ts